import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../services/general/toast.service';

@Component({
  selector: 'app-modal-revise-question',
  templateUrl: './modal-revise-question.component.html',
  styleUrls: ['./modal-revise-question.component.scss'],
  standalone: false
})
export class ModalReviseQuestionComponent implements OnInit {
  originalQuestion: any;
  newQuestion: any;

  constructor(
    public dialogRef: MatDialogRef<ModalReviseQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
    private toast: ToastService
  ) {
    this.originalQuestion = data.question;
  }

  ngOnInit(): void {
    if (this.originalQuestion?.customs?.revision_question) {
      this.newQuestion = this.originalQuestion.customs.revision_question;
    } else {
      this.newQuestion = JSON.parse(JSON.stringify(this.originalQuestion));
      // Pre-fill with the AI rewriting pipeline result, when available.
      if (this.data?.rewritten_statement) {
        this.newQuestion.question = this.data.rewritten_statement;
      }
    }
    this.newQuestion.id = 1; // Temporary ID
    this.newQuestion.is_new = true;
    // Clear response data if any
    this.newQuestion.response = {customs: {}, attachments: []};
  }

  save() {
    if (!this.newQuestion.question) {
      this.toast.error(
        this.translateService.instant('generic.error'),
        this.translateService.instant('modals.modal-survey-details.errors.title-is-required')
      );
      return;
    }

    this.dialogRef.close(this.newQuestion);
  }

  close() {
    this.dialogRef.close();
  }
}
